import { useState } from 'react';
import UserProfileModal from './UserProfileModal';

/**
 * Rend un nom d'utilisateur cliquable pour ouvrir sa fiche de contact.
 * Usage: <ClickableUser userId="xxx" name="Jean Dupont" />
 */
export function ClickableUser({ userId, name, className = '', children }) {
    const [open, setOpen] = useState(false);

    if (!userId || !name) return <span className={className}>{children || name || '—'}</span>;

    return (
        <>
            <button
                onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                className={`hover:underline hover:text-blue-600 transition-colors cursor-pointer text-left ${className}`}
                data-testid={`user-link-${userId}`}
                title="Voir les coordonnées"
            >
                {children || name}
            </button>
            <UserProfileModal userId={userId} isOpen={open} onClose={() => setOpen(false)} />
        </>
    );
}

export default ClickableUser;
